module.exports = __webpack_public_path__ + "img/07_shimizu_17.ceb607ca.jpg";